<template>
    <div v-if="questions && Object.keys(questions).length" class="mb-42">

        <application-title :title="$t('applications.extra_questions')"/>

        <table v-if="context !== 'interim'"
               class="border-collapse text-left w-full border-0 rounded-6 overflow-hidden">
            <tr
                v-for="question in form_questions"
                :key="'question-' + question.key"
                class="w-full"
            >

                <th :title="question.question[locale]" class="w-1/2 pr-16 align-top py-12 first-letter:uppercase whitespace-pre-wrap-line">
                    {{ question.question[locale] || Object.values(question.question).find(entry => !!entry) }} :
                </th>
                <td class="w-1/2 py-12 pr-16 align-top">
                    <div v-if="question.question_type === 'multiple_choice'">
                        <ul v-if="question.multiple" class="list-inside list-disc">
                            <li v-for="answer in application_questions[question.key]">
                                {{ answer }}
                            </li>
                        </ul>
                        <span v-else>{{ application_questions[question.key] }}</span>
                    </div>
                    <div v-else-if="question.question_type === 'yes_no'">
                        <span v-if="application_questions[question.key] == 1 || application_questions[question.key] == 'yes'">{{ $t('general.yes') }}</span>
                        <span v-else>{{ $t('general.no') }}</span>
                    </div>
                    <div v-else class="mr-auto">{{ application_questions[question.key] }}</div>
                </td>
            </tr>
        </table>
        <table v-else class="border-collapse text-left w-full border-0 rounded-6 overflow-hidden">
            <tr
                v-for="question in questions"
                :key="'question-' + question.key"
                class="w-full"
            >

                <th :title="question.question[locale]"
                    class="w-1/2 pr-16 align-top py-12 first-letter:uppercase whitespace-pre-wrap-line">
                    {{ question.question[locale] || Object.values(question.question).find(entry => !!entry) }} :
                </th>
                <td class="w-1/2 py-12 pr-16 align-top">
                    <div v-if="question.question_type === 'multiple_choice'">
                        <ul v-if="question.multiple" class="list-inside list-disc">
                            <li v-for="answer in question.answer">
                                {{ answer }}
                            </li>
                        </ul>
                        <span v-else>{{ question.answer }}</span>
                    </div>
                    <div v-else-if="question.question_type === 'yes_no'">
                        <span v-if="question.answer == 1 || question.answer == 'yes'">{{ $t('general.yes') }}</span>
                        <span v-else>{{ $t('general.no') }}</span>
                    </div>
                    <div v-else class="mr-auto">{{ question.answer }}</div>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>

import SvgIcon from './ui/SvgIcon';
import ApplicationTitle from "./applications/ApplicationTitle.vue";
import {mapStores} from "pinia";
import {useMainStore} from "../state/store";

export default {
    components: {ApplicationTitle, SvgIcon},
    props: {
        application_questions: Array / Object,
        questions: Array / Object,
        form_questions: Array,
        context: String,
    },
    computed: {
        ...mapStores(useMainStore),
        locale() {
            return this.mainStore.locale;
        }
    },
};
</script>
